<form [formGroup]="filterForm">
  <ng-container *ngFor="let filter of filterConfigs">
    <span *ngIf="filter.name === 'filterTitle' && filterCheck(filter)">
      Filtra i risultati
    </span>

    <!-- <span *ngIf="(userLevel === 'Sito' && type !== 'forecast') || (userLevel !== 'Sito') || (type !== 'administration')">
    Filtra i risultati
  </span> -->

    <!-- <ng-container *ngIf="type === '/administration/sites' || type === '/administration/cer'">
    <mat-form-field class="filter-field" appearance="outline">
      <input matInput formControlName="textSearch" placeholder="Cerca">
    </mat-form-field>
  </ng-container> -->


    <!-- <ng-container *ngIf="type === '/history' || type === '/incentive/calculate'"> -->
    <ng-container *ngIf="filter.name === 'periodType' && filterCheck(filter)">
      <mat-form-field class="filter-field" appearance="outline">
        <mat-label>Filtra per</mat-label>
        <mat-select formControlName="periodType">
          <mat-option *ngFor="let period of historyPeriods" (click)="changePeriodType(period.value)"
            [value]="period.value">
            {{period.label}}
          </mat-option>
          <!-- <ng-container *ngIf="type === 'predictive'">
              <mat-option *ngFor="let period of predictivePeriods" (click)="changePeriodType(period.value)"
              [value]="period.value">
              {{period.label}}
            </mat-option>
          </ng-container> -->
        </mat-select>
      </mat-form-field>
    </ng-container>

    <ng-container *ngIf="filter.name === 'periodValue' && filterCheck(filter)">
      <!-- <ng-container *ngIf="type === '/history' || type === '/incentive/calculate'"> -->
      <mat-form-field class="filter-field" appearance="outline" *ngIf="selectedPeriodType === 'days'">
        <mat-label>Seleziona periodo</mat-label>
        <mat-select formControlName="periodValue">
          <mat-option *ngFor="let option of historyOptions" [value]="option.value">
            {{option.name}}
          </mat-option>
          <!-- <ng-container *ngIf="type === 'predictive'">
          <mat-option *ngFor="let option of predictiveOptions" [value]="option.value">
            {{option.name}}
          </mat-option>
        </ng-container> -->
        </mat-select>
      </mat-form-field>
    </ng-container>

    <ng-container *ngIf="filter.name === 'monthList' && filterCheck(filter) && selectedPeriodType === 'months'">
      <mat-form-field class="filter-field" appearance="outline">
        <mat-label>Seleziona il mese</mat-label>
        <mat-select formControlName="monthList">
          <mat-option *ngFor="let month of months" [value]="month.value">
            {{ month.label| date: 'LLLL' }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>

    <ng-container *ngIf="filter.name === 'customRange' && filterCheck(filter) && selectedPeriodType === 'custom'">
      <mat-form-field class="example-form-field filter-field" appearance="outline">
        <mat-label>Da data a data (max 15 gg)</mat-label>
        <mat-date-range-input [formGroup]="customRange" [rangePicker]="rangePicker" [max]="maxDate">
          <input matStartDate formControlName="start" placeholder="Da data">
          <input matEndDate formControlName="end" placeholder="A data">
        </mat-date-range-input>
        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
        <mat-date-range-picker maxRange="14" #rangePicker>
          <mat-date-range-picker-actions>
            <div class="text-error" style="margin-right: 20px; font-weight: bold;">Max 15 gg</div>
            <button mat-raised-button color="secondary" matDateRangePickerCancel>Annulla</button>
            <button mat-raised-button color="primary" matDateRangePickerApply
              (click)="collectCustomPeriod()">Applica</button>
          </mat-date-range-picker-actions>
        </mat-date-range-picker>
      </mat-form-field>
    </ng-container>

    <ng-container *ngIf="filter.name === 'yearsList' && filterCheck(filter)">
      <!-- <ng-container *ngIf="type === '/history' || type === '/incentive/calculate'"> -->
      <mat-form-field class="filter-field" appearance="outline">
        <mat-label>Anno</mat-label>
        <mat-select formControlName="yearsList">
          <mat-option *ngFor="let year of getYears()" [value]="year">
            {{year}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>

    <!-- <ng-container *ngIf="userLevel !== 'Sito'" >     -->
    <ng-container *ngIf="filter.name === 'site' && filterCheck(filter)">
      <mat-form-field class="filter-field" appearance="outline">
        <mat-label>Seleziona il site</mat-label>
        <mat-select formControlName="site">
          <mat-option [value]="'total'">
            Tutti i sites
          </mat-option>
          <mat-option *ngFor="let site of sites" [value]="site.id">
            {{site.description}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>

    <ng-container *ngIf="filter.name === 'filterButton' && filterCheck(filter)">
      <button mat-raised-button color="primary" class="filter" (click)="onSubmit()">Filtra</button>
    </ng-container>

  </ng-container>
</form>